import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import MainContentBg from "../../Assets/images/fraudArmorHomeMainBg.jpg";
import infoIconHelp from "../../Assets/images/info_icon_sprite.png";
import { useTranslation } from "react-i18next";
import { ApplicationState } from "../../../store";
import PSSBannerMessage from "../PSSBannerMessage/PSSBannerMessage";
import * as httpClient from "../../../util/httpClient";

const PssSisk = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );

    useEffect(() => {
        setTimeout(() => {
            let language =
                !!partnerLanguageOptions && partnerLanguageOptions.length > 1
                    ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language").length > 0
                        ? !!document.cookie
                              .split(";")
                              .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                              .split("=")[1]
                            ? document.cookie
                                  .split(";")
                                  .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                                  .split("=")[1]
                            : "en"
                        : "en"
                    : "en";
            i18nLang.changeLanguage(language);
        });
    }, []);


    const query = new URLSearchParams(props.location.search);
    let code: any = query.get("Accesscode");
    code = code?.includes(" ") ? code.replace(/\s/g, "+") : code;

    const { register, errors, handleSubmit, reset, trigger, setValue } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: {
            memberID: code ? code : "",
        },
    });
    const [showAccessCodeField, setShowAccessCodeField] = useState(false);
    const [state, setState] = useState({
        memberID: "",
        showErrorMessage: false,
        errorMsg: "Offer Code is Required",
        isLoading: false,
    });
    const handleInputChange = (event: any) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        if (name === "") {
            setState({
                ...state,
                [name]: value,
                showErrorMessage: false,
            });
        } else {
            setState({
                ...state,
                [name]: value,
            });
        }
    };
    useEffect(() => {
        if (code != "" && code != null) {
            const data = {
                memberID: code
            };
            onSubmit(data);
        }
    }, [code])

    const onSubmit = (data: any) => {
        setState({ ...state, isLoading: true });
        const requestBody = {
            provisionalID: data.memberID,
            partnerID: partnerID,
        };
        httpClient
            .sendRequest("POST", "api/PssLandingPage/GetPssLandingPage1?enrollFileRequired=true", requestBody)
            .then((data) => {
                if (data.provisionalResponseLanding.length === 0) {
                    setShowAccessCodeField(true);
                } else if (data.provisionalResponseLanding.length != 0) {
                    props.history.push({
                        pathname:
                            "/Register?Type=" +
                            data.provisionalResponseLanding[0].contractStatus +
                            "&VALUE=" +
                            data.provisionalResponseLanding[0].provisionalID +
                            "&GNDNRLL=PSS",
                    });
                    window.location.reload();
                }
            })
            .catch(function (error) {
                reset();
                trigger();
                setState({ ...state, showErrorMessage: true, errorMsg: "Something went wrong. Please try again.", isLoading: false });
            });
    };
    return (
        <React.Fragment>
            {showAccessCodeField == true ? <PSSBannerMessage layout={"psssisk"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} /> : null}
            <div id="pss6-main">
                <main is="x3d" id="l-page-content main-content">
                    <div className="row pss6-full-container">
                        <div className="pss6-left-content">
                            <h1 className="pss6-top-header">
                                Identity Thieves
                                <br /> Don't Rest.
                            </h1>
                            <span className="pss6-top-header-span">
                                Luckily, neither does IdentityForce. We monitor <br />
                                your personal information 24/7, quickly alert <br />
                                you to threats, and help protect you.
                            </span>
                            <h3>
                                Protect What Matters Most.<sup>TM</sup>
                            </h3>
                            <span className="pss6-bottomcontent">
                                By subscribing to these services you agree that IdentityForce 
                                will share your information with your Financial Institution 
                                and Sisk, who are offering these to you. Personal information 
                                includes first name, last name, and email address.
                            </span>
                        </div>
                        <div className="pss6-right-content">
                            <h2>Create Your IdentityForce Account</h2>
                            <div className="pss6receiptCodeCopy">Simply enter your Member ID to get started.</div>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="pss6form">
                                    <label htmlFor="memberID">Member ID</label>
                                    <div className="row pss6-form-input">
                                        <div className="pss6-forms-mobile">
                                            <input
                                                aria-required="true"
                                                name="memberID"
                                                type="text"
                                                id="memberID"
                                                className="field lp_half_field"
                                                onChange={handleInputChange}
                                                ref={register({
                                                    required: true,
                                                    maxLength: 100,
                                                })}
                                            />
                                            {errors.memberID && errors.memberID.type === "required" && (
                                                <div role="alert" className="col-xs-12 col-no-gutter">
                                                    <span className="error-msg">Member ID is required</span>
                                                </div>
                                            )}
                                        </div>
                                        <button id="" className="pss6getstartedbutton getStartedButton" >Get Started</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </main>
                </div>
        </React.Fragment>
    );
};
export default PssSisk;
